export function hasPromptAPI() {
  return typeof window.LanguageModel?.create === 'function'
}

export type PromptSession = Awaited<ReturnType<NonNullable<Window['LanguageModel']>['create']>>

export function createPromptSession(system: string) {
  const LanguageModel = window.LanguageModel
  if (typeof LanguageModel?.create !== 'function') return

  return LanguageModel.create({
    initialPrompts: [{ role: 'system', content: system }]
  })
}
